import React, { useState, lazy } from 'react';
import { Section } from './ui/Section';
export function PreviewImages() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/oxkh1kvUSa7H9KunbAoyPt/WhatsApp_Image_2026-06-11_at_10.35.45_(1).webp',
    caption: 'Plan de Negocio: Del Instructor al Empresario'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/rY2Jm1xBn7bv1xaoiKyw3P/WhatsApp_Image_2026-06-11_at_10.35.45_(2)_(1).webp',
    caption: 'Tu Hoja de Ruta: Los primeros 7 días de acción'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/gWpHEQR5cEPpzcmKVwPprz/WhatsApp_Image_2026-06-11_at_10.35.44.webp',
    caption: 'Sistemas de Fidelización y Progreso Visible'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/8fTPwiS5Kk6fA12SDvqpQi/WhatsApp_Image_2026-06-11_at_10.35.45.webp',
    caption: 'Guía de Comportamiento y Protocolos Anti-Baja'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % images.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + images.length) % images.length);
  };
  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };
  return <Section className="bg-brand-bg" data-id="element-221">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-12 text-brand-title" data-id="element-222">
        📸 MIRA EL MATERIAL POR DENTRO
      </h2>

      <div className="max-w-4xl mx-auto" data-id="element-223">
        {/* Carousel Container */}
        <div className="relative" data-id="element-224">
          {/* Main Image Container */}
          <div className="relative overflow-hidden" data-id="element-225">
            <div className="flex transition-transform duration-500 ease-out" style={{
            transform: `translateX(-${currentSlide * 100}%)`
          }} data-id="element-226">
              {images.map((image, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-227">
                  <div className="bg-white border border-brand-border rounded-xl p-4 shadow-card" data-id="element-228">
                    <img src={image.url} alt={image.caption} width="800" height="1200" loading="lazy" decoding="async" className="w-full h-auto rounded-lg" data-id="element-229" />
                    <p className="text-center text-brand-text font-body font-medium mt-4 text-sm md:text-base" data-id="element-230">
                      {image.caption}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-brand-title p-3 rounded-full shadow-lg transition-all hover:scale-110 z-10" aria-label="Previous slide" data-id="element-231">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-232">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-233" />
            </svg>
          </button>

          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-brand-title p-3 rounded-full shadow-lg transition-all hover:scale-110 z-10" aria-label="Next slide" data-id="element-234">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-235">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-236" />
            </svg>
          </button>
        </div>

        {/* Dots Indicator */}
        <div className="flex justify-center gap-2 mt-8" data-id="element-237">
          {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-brand-title w-8' : 'bg-brand-border hover:bg-brand-title/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-238" />)}
        </div>

        {/* Mobile Swipe Hint */}
        <p className="text-center text-brand-textMuted text-sm mt-6 md:hidden" data-id="element-239">
          ← Desliza para ver más →
        </p>
      </div>
    </Section>;
}